export default "__VITE_ASSET__Z2ddSrCX__"